export default {
    inside: 50,
    outside: 200,
}